module.exports = __webpack_public_path__ + "img/prevPage1.1e65e593.png";